import { render, staticRenderFns } from "./tagbox-item.vue?vue&type=template&id=46c763d0&"
import script from "./tagbox-item.vue?vue&type=script&lang=ts&"
export * from "./tagbox-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c763d0')) {
      api.createRecord('46c763d0', component.options)
    } else {
      api.reload('46c763d0', component.options)
    }
    module.hot.accept("./tagbox-item.vue?vue&type=template&id=46c763d0&", function () {
      api.rerender('46c763d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/tagbox/tagbox-item.vue"
export default component.exports